export default __webpack_public_path__ + "static/media/Q14_4_resized.69f916f6.jpg";